


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { SquareAccountAddOrUpdateViewModel } from '@/models/payment/squareAccount';
import { Base } from '@/components/common/base';
import {storeService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class AddSquareAccountPage extends Base {
  public vm: SquareAccountAddOrUpdateViewModel = new SquareAccountAddOrUpdateViewModel();
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public disableSubmitButton: boolean = false;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public created(): void {
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.vm.storeId.toString(), tab: 'SquareAccount' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('cenposAccounts.alertFormInvalid'));
        this.resetMethodName(methodName);
        return;
      }
      this.submitCenposAccount();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('stores.btnBackToStoreTitle'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('stores.btnBack'),
      click: 'backToStoreEdit',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setFields();
    this.vm.storeId = Number(this.$route.params.storeId);
   
    this.getSquareAccountDetails();
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'environment',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          required: true,
          label: 'Environment',
          items: [
            'Production',
            'Sandbox',
          ],
          loading: false,
          rules:[
            v => this.required('Environment',v)
          ]
        },
      },
      {
        key: 'applicationId',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 150,
          label: 'ApplicationId',
          required: true,
          disabled: false,
          rules:[
            v => this.required('Application Id',v)
          ]
        },
      },
      {
        key: 'accessToken',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 250,
          label: 'Access Token',
          required: true,
          disabled: false,
          rules:[
            v => this.required('Access Token',v)
          ]
        },
      },
      
    ];
  }

  public validateCenposAccountForm(): Vue & { validate: () => boolean } {
    return this.$refs.cenposAccountForm as Vue & { validate: () => boolean };
  }

  public async submitCenposAccount(): Promise<void> {
    if(this.validateCenposAccountForm().validate()){
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        await storeService.updateSquareAccounts(
          this.vm.storeId,
          this.vm.account
        );
        this.showAlert(true, this.$t('squareAccounts.alertSaveSquareAccount'));
    
        this.$router.push({
          name: 'admin.stores.edit',
          params: {
            tenantId: this.tenantId.toString(),
            enterpriseId: this.enterpriseId.toString(),
            storeId: this.vm.storeId.toString(),
            tab: 'SquareAccount'
          },
        });
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }

  public async getSquareAccountDetails(): Promise<void> {
    try {
      if (this.vm.applicationId) {
        this.formlyShowSkeleton(this.formFields);
      }

      const response = await storeService.getSquareAccountDetails(
        this.vm.storeId
      );
      if (response) {
        this.vm.account = response;
      }
    } finally {
      if (this.vm.applicationId) {
        this.formlyHideSkeleton(this.formFields);
      }
    }
  }
}
